<template>
  <footer class="app-footer">

    <!-- 底部版权栏 -->
    <div class="app-footer__bottom">
      <div class="container app-footer__bottom-inner">
        <span class="app-footer__copyright">&copy; 2016 A.C Asset Management Limited. All rights reserved.</span>
      </div>
    </div>
  </footer>
</template>

<script setup>

</script>

<style scoped>
.app-footer {
  background: #22262e;
  border-top: 1px solid var(--color-border);
  color: #fff;
}

.app-footer__main {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: var(--space-16);
  padding-top: var(--space-16);
  padding-bottom: var(--space-12);
}

/* 列标题 */
.app-footer__col-title {
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--color-text-primary);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: var(--space-6);
}

/* 公司信息 */
.app-footer__brand {
  font-family: var(--font-serif);
  font-size: var(--text-lg);
  font-weight: 600;
  color: #a8b0bd;
  margin-bottom: var(--space-3);
}

.app-footer__desc {
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  line-height: 1.7;
  color: var(--color-text-muted);
  margin-bottom: var(--space-4);
  max-width: 360px;
}

.app-footer__filing {
  font-family: var(--font-sans);
  font-size: var(--text-xs);
  color: var(--color-text-muted);
  opacity: 0.6;
}

/* 链接列表 */
.app-footer__links {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.app-footer__link {
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  text-decoration: none;
  transition: color var(--transition-fast), padding-left var(--transition-fast);
  display: inline-block;
  position: relative;
  padding-left: 0;
}

.app-footer__link::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 1px;
  background: var(--color-accent);
  transition: width var(--transition-base);
}

.app-footer__link:hover {
  color: var(--color-accent);
  padding-left: var(--space-3);
}

.app-footer__link:hover::before {
  width: var(--space-2);
}

/* 联系方式占位 */
.app-footer__contact-item {
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  color: var(--color-text-muted);
  line-height: 1.8;
}

/* 底部版权栏 */
.app-footer__bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: var(--space-6) 0;
}

.app-footer__bottom-inner {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.app-footer__copyright {
  font-family: var(--font-sans);
  font-size: var(--text-xs);
  color: rgba(168, 176, 189, 0.7);
  line-height: 1.6;
}

/* 响应式 */
@media (max-width: 768px) {
  .app-footer__main {
    grid-template-columns: 1fr;
    gap: var(--space-10);
    padding-top: var(--space-10);
    padding-bottom: var(--space-8);
  }

  .app-footer__desc {
    max-width: 100%;
  }

  .app-footer__bottom-inner {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-3);
  }

  .app-footer__copyright {
    text-align: left;
    max-width: 100%;
  }
}
</style>
